module.exports = __webpack_public_path__ + "img/pijltje-dropdown.072b5c3e244f36d10aaafebd9585ab82.svg";